import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { PatchQueueRequestComment } from 'domain/usecases';
import { RemotePatchQueueRequestComment } from 'data/usecases';

export const makeRemotePatchQueueRequestComment = (commentId: string): PatchQueueRequestComment => {
  return new RemotePatchQueueRequestComment(
    makeApiUrl(`/queue/requests/comments/${commentId}`),
    makeAuthorizeHttpClientDecorator()
  );
};
